import { useTranslation } from "next-i18next";
import { EmptyState } from "src/components/common/empty-state";
import { IconCommenting } from "src/components/icons";

export const CommentAreaEmptyState = () => {
    const { t } = useTranslation("comment");
    return (
        <EmptyState CustomIcon={<IconCommenting width={["80px", "135px"]} height={["57px", "97px"]} />} title={t("empty-state.no-comments-yet")} />
    );
};
